import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import QuestionNumber from "./../QuestionNumber";

import axios from "axios";
import Webcam from "react-webcam";
import config from "../../config/config-secret.json";
import { nextQuestion } from "./../../actions/assessment";

let count = 0;

export class AgreeDisagree extends Component {
  constructor(props) {
    super(props);

    this.webcamRef = React.createRef();
  }

  componentDidMount() {
    count = 0;
    // SaveUserStateToServerHelper(this.props.assessment);
  }

  checkRadioButton = (event) => {
    const node = ReactDOM.findDOMNode(this);
    if (node instanceof HTMLElement) {
      const radioButton = node.querySelector("#" + event.target.htmlFor);
      if (radioButton) {
        radioButton.checked = true;
      }
    }
  };

  uncheckRadioButton = (event) => {
    const node = ReactDOM.findDOMNode(this);
    if (node instanceof HTMLElement) {
      const radioButton = node.querySelector("#" + event.target.htmlFor);
      if (radioButton) {
        radioButton.checked = false;
      }
    }
  };

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  onUserMedia = () => {};

  addCaptureImage = (imageb64, taken_at) => {
    axios
      .post(config.API_URL + `/administer_test/save_security_image/`, {
        imageb64,
        taken_at,
        tester_id: this.props.assessment.tester_id,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  nextQuestion = async (id) => {
    if (count < 1) {
      count += 1;
      window.localStorage.setItem(
        this.props.assessment.key,
        JSON.stringify(this.props.assessment)
      );

      const { tester_id, ...last_session_info } = this.props.assessment;
      axios
        .post(config.API_URL + "/administer_test/update_tester_session_info/", {
          tester_id: tester_id,
          last_session_info: JSON.stringify(last_session_info),
        })
        .then((res) => {
          document.querySelector("#initloader").style.display = "none";
          this.props.nextQuestion(this.props.question_id, [id]);
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.log(error);
          alert(
            "We are having issues sending the data to our server. Please check your internet connection and try to refresh your browser. If the issue persists, please contact your administrator."
          );
        });
    }
  };

  render() {
    return (
      <div className="question">
        {this.props.assessment.has_security_features && (
          <Webcam
            className="col-12 mb-4"
            style={{
              position: "absolute",
              right: "100%",
              display: "block",
            }}
            screenshotFormat="image/jpeg"
            muted={false}
            ref={this.webcamRef}
            onUserMediaError={this.onUserMediaError}
            onUserMedia={this.onUserMedia}
          />
        )}

        <QuestionNumber />

        {/* {this.props.instrunction && (
          // <p className="quesion-sub">{this.props.instrunction}</p>
        )} */}
        <h4>
          <span
            dangerouslySetInnerHTML={{ __html: this.props.questiontext }}
          ></span>
          {/* <span>{this.props.questiontext}</span> */}
        </h4>

        <div
          className="choices-btn choices-btn-scale btn-group d-xs-block"
          data-toggle="buttons"
        >
          {this.props.choices.map((value, index) => {
            return (
              <label
                key={value.id}
                className="btn btn-outline-light"
                htmlFor={"rdbAgreeDisagree" + value.id}
                onClick={() => {
                  this.nextQuestion(value.id);

                  if (this.props.assessment.has_security_features) {
                    this.addCaptureImage(
                      this.webcamRef.current.getScreenshot(),
                      new Date()
                    );
                  }
                }}
                onMouseEnter={this.checkRadioButton}
                onMouseLeave={this.uncheckRadioButton}
                onTouchStart={this.checkRadioButton}
                onTouchCancel={this.uncheckRadioButton}
              >
                <div key={value.id} className="custom-control custom-radio">
                  <input
                    type="radio"
                    key={value.id}
                    id={"rdbAgreeDisagree" + value.id}
                    name="choices"
                    className="with-gap"
                    value={value.value}
                  />
                  <label
                    className="custom-control-label rdb-choice"
                    htmlFor={"rdbAgreeDisagree" + value.id}
                  >
                    <span className="custom-radio-text">
                      {value.choice.text}
                    </span>
                  </label>
                </div>
              </label>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  nextQuestion: (question_id, choice_ids) =>
    dispatch(nextQuestion(question_id, choice_ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgreeDisagree);
